import { getReadableUnixTimeAnsi } from './../GlobalFunctions';
import styles from './../SCSS/ClassroomDashboard.module.scss';

interface JournalEntry {
  0: string;
  1: number;
  2: string;
}

interface StudentProfileModalBodyHeaderProps {
  journalHistory: Record<string, JournalEntry>;
}

const colorMap: Record<string, string[]> = {
  Calm: ['#FFE0D1', '#54595D', 'Y'],
  Sad: ['#C0E8F2', '#54595D', 'B'],
  'No check-in': ['#F2F2F2', '#54595D', 'N'],
  Happy: ['#FF7735', '#54595D', 'Y'],
  Excited: ['#FF5305', '#54595D', 'Y'],
  Angry: ['#00A3D3', '#54595D', 'B'],
  Nervous: ['#1EC5EA', '#54595D', 'B'],
};

const StudentProfileModalBodyHeader = ({ journalHistory }: StudentProfileModalBodyHeaderProps): JSX.Element => {
  const generateJournalHistory = () => {
    if (journalHistory) {
      const outputJournal = [];

      let idx = 0;
      for (const key in journalHistory) {
        const date = getReadableUnixTimeAnsi(journalHistory[key][1]);
        const mood = journalHistory[key][0];
        const msg = journalHistory[key][2];
        const dateAndTimeStringArray = date.split(' ');
        const dateString = dateAndTimeStringArray.slice(0, -1).join(' ');
        const timestampString = dateAndTimeStringArray.slice(-1).join(' ');
        outputJournal.push(
          <div key={(idx += 1)} className={styles.journalElement}>
            <div className={styles.journalDate}>
              <p>{dateString}</p>
              <p>{timestampString}</p>
            </div>
            <div
              className={styles.mood}
              style={{
                backgroundColor: colorMap[mood][0],
                color: colorMap[mood][1],
              }}
            >
              {mood}
            </div>
            <div className={styles.journalContent}>{msg}</div>
          </div>,
        );
      }

      return outputJournal;
    }
    return null;
  };
  return (
    <>
      <div className={styles.journalHeader}>
        <span>Journal</span>
      </div>
      <div className={styles.journalHistory}>{generateJournalHistory()}</div>
    </>
  );
};

export default StudentProfileModalBodyHeader;
